import {
  GET_EVENTS_LIST,
  GET_EVENT_INFO,
  GET_EDITABLE_EVENT_ACTION,
  getEventInfoActionSuccess,
  getEventInfoActionError,
  getEventsListActionSuccess,
  getEventsListActionError,
  getEditableEventActionSuccess,
  getEditableEventActionError,
  SET_EDITABLE_EVENT_ACTION,
  setEditableEventActionSuccess,
  setEditableEventActionError,
  CREATE_EVENT_ACTION,
  createEventActionSuccess,
  createEventActionError,
  redirectAction,
  openModalAction,
  getMyEventsAction,
  GET_MY_EVENTS,
  getMyEventsSuccess,
  getMyEventsError,
  checkIsUserOwnerOfMissionSuccess,
  checkIsUserOwnerOfMissionError,
  DELETE_MISSION_ACTION,
  GET_EVENT_INFO_SUCCESS,
  GET_ALL_EVENTS_LIST,
  getEventInfoEndUpdatesAction,
} from "store/actions";
import { ofType } from "redux-observable";
import {
  switchMap,
  map,
  catchError,
  concatMap,
  withLatestFrom,
} from "rxjs/operators";
import { of, forkJoin, EMPTY, interval } from "rxjs";
import moment from "moment";

export const fetchEventByIdEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_EVENT_INFO),
    switchMap(({ payload }) =>
      request(`${url}/events/${payload}`).pipe(
        map(({ response }) => getEventInfoActionSuccess(response)),
        catchError((err) => of(getEventInfoActionError(err)))
      )
    )
  );

export const fetchAllFutureEventsEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_EVENTS_LIST),
    switchMap(() =>
      request(`${url}/events`, {
        headers: {
          "Content-Type": "application/json",
          "future-event-limit": 100,
        },
      }).pipe(
        map(({ response }) => getEventsListActionSuccess(response)),
        catchError((err) => of(getEventsListActionError(err)))
      )
    )
  );

//todo change the success/error actions
export const fetchAllEventsEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_ALL_EVENTS_LIST),
    switchMap(() =>
      request(`${url}/events`).pipe(
        map(({ response }) => getEventsListActionSuccess(response)),
        catchError((err) => of(getEventsListActionError(err)))
      )
    )
  );

export const fetchEditableEventEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_EDITABLE_EVENT_ACTION),
    switchMap(({ payload }) => {
      return forkJoin([
        request(`${url}/events/${payload}`),
        request(`${url}/editors/${payload}`),
      ]).pipe(
        map(([{ response }]) => getEditableEventActionSuccess(response)),
        catchError((err) => of(getEditableEventActionError(err)))
      );
    })
  );

export const fetchMyEventsEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_MY_EVENTS),
    switchMap(() =>
      request(`${url}/myevents`).pipe(
        map(({ response }) => getMyEventsSuccess(response)),
        catchError((err) => of(getMyEventsError(err)))
      )
    )
  );

/**
 * When any user loads a mission, check if they are the editor,
 * if they are the success renders an edit button on /events/:id page
 */
export const checkIsUserOwnerOfMission = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(GET_EVENT_INFO),
    switchMap(({ payload }) =>
      request(`${url}/editors/${payload}`).pipe(
        map(({ response }) => checkIsUserOwnerOfMissionSuccess(response)),
        catchError((err) => of(checkIsUserOwnerOfMissionError(err)))
      )
    )
  );

export const updateEditableEventEpic = (
  action$,
  _,
  { url, location, request }
) =>
  action$.pipe(
    ofType(SET_EDITABLE_EVENT_ACTION),
    switchMap(({ payload }) => {
      const options = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Expose-Headers": "Content-Type, Location",
        },
        body: JSON.stringify({
          ...payload,
        }),
      };

      return request(`${url}/events`, options).pipe(
        concatMap(({ response }) =>
          of(
            setEditableEventActionSuccess(response),
            redirectAction(`/events/${location.pathname.split("/")[2]}`),
            openModalAction(
              "Mission successfully updated. You can now share your mission."
            )
          )
        ),
        catchError((err) => of(setEditableEventActionError(err)))
      );
    })
  );

export const createEventEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(CREATE_EVENT_ACTION),
    switchMap(({ payload }) => {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          ...payload,
        }),
      };
      return request(`${url}/events`, options).pipe(
        concatMap((res) => {
          const { response, xhr } = res;
          const location = xhr.getResponseHeader("location");
          return of(
            createEventActionSuccess(response),
            redirectAction(`/events/${location}`),
            openModalAction(
              "Mission successfully created. You can now share your mission."
            )
          );
        }),
        catchError((err) => of(createEventActionError(err)))
      );
    })
  );

export const deleteMissionEpic = (action$, _, { url, request }) =>
  action$.pipe(
    ofType(DELETE_MISSION_ACTION),
    switchMap(({ payload }) => {
      const options = {
        method: "DELETE",
      };
      return request(`${url}/events/${payload}`, options).pipe(
        map(() => getMyEventsAction()),
        catchError(() => EMPTY)
      );
    })
  );

export const pollEventEpic = (
  action$,
  state$,
  {
    config: { poll_event_timer_in_seconds, max_poll_refresh_amount },
    url,
    request,
    location,
  }
) =>
  action$.pipe(
    ofType(GET_EVENT_INFO_SUCCESS),
    withLatestFrom(state$),
    switchMap(
      ([
        _,
        {
          rootReducer: {
            orbat: {
              selectedEvent: {
                event: { event_date },
                event_id,
                numTimesRequested,
              },
            },
          },
        },
      ]) => {
        if (
          location.pathname !== `/events/${event_id}` ||
          numTimesRequested >= max_poll_refresh_amount ||
          moment(event_date).isBefore(moment().subtract(1, "days"))
        ) {
          return of(getEventInfoEndUpdatesAction());
        }
        return interval(poll_event_timer_in_seconds * 1000).pipe(
          concatMap(() => {
            return request(`${url}/events/${event_id}`).pipe(
              map(({ response }) => getEventInfoActionSuccess(response)),
              catchError((err) => of(getEventInfoActionError(err)))
            );
          })
        );
      }
    )
  );
